import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

import { Constants } from '../../shared/models/constants';
import { EmitEvent, EventBusService, Events } from '../services/event-bus.service';

@Injectable()
export class OverlayRequestResponseInterceptor implements HttpInterceptor {

  constructor(private eventBus: EventBusService) { }

  private shouldTrackOverlay(url: string): boolean {
    return Constants.shouldTrackOverlay(url);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // const randomTime = this.getRandomIntInclusive(0, 1500);
    const tracked = this.shouldTrackOverlay(req.url);
    let emittedResponseEvent = false;
    this.eventBus.emit(new EmitEvent(Events.httpRequest, req));
    return next
      .handle(req)
      .pipe(
        // delay(randomTime),  // Simulate random Http call delays
        tap(event => {
          if (event instanceof HttpResponse) {
            emittedResponseEvent = true;
            this.eventBus.emit(new EmitEvent(Events.httpResponse, { url: req.url, tracked }));
          }
        }),
        finalize(() => {
          // Covers cancellation/unsubscribe paths where no HttpResponse is emitted.
          if (!emittedResponseEvent) {
            this.eventBus.emit(new EmitEvent(Events.httpResponse, { url: req.url, tracked }));
          }
        })
      );
  }

  getRandomIntInclusive(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min; // The maximum is inclusive and the minimum is inclusive
  }

}
